/* eslint css-modules/no-unused-class: [2, { markAsUsed: ['size-s', 'size-m', 'color-black', 'color-soft-info', 'color-info', 'color-highlight', 'color-critical'] }] */

import { FC } from 'react';

import cn from 'classnames';

import type { BaseComponentProps } from '../../../types/common';
import { H7 } from '../Typography';

import styles from './Badge.module.css';

export interface BadgeProps extends BaseComponentProps {
  /**
   * Text to display in the badge
   */
  text: string;
  /**
   * Color of the badge, default is black
   */
  variant?: 'soft-info' | 'info' | 'highlight' | 'critical';
  /**
   * Size of the badge, default is m
   */
  size?: 's' | 'm';
}

/**
 * Badge component to know non-interactive status of an element
 */
export const Badge: FC<BadgeProps> = ({
  size = 'm',
  variant = 'soft-info',
  text,
  dataTestId,
}: BadgeProps) => {
  return (
    <div
      className={cn(
        styles.badge,
        styles[`size-${size}`],
        styles[`color-${variant}`]
      )}
      data-testid={dataTestId}
    >
      <H7 bold color="inherit">
        {text}
      </H7>
    </div>
  );
};
